<template>
    <div class="p-20 bg-white">
        <Button type="primary" @click="newEseal">新订单</Button>
        <Table :data="sealActiveList.content" border :columns="col" class="m-t-20">
        </Table>
        <div class="text-r p-20">
            <Page :total="sealActiveList.totalElements" show-elevator show-total :page-size="20" size="small"
                  @on-change="getSealActiveList"></Page>
        </div>
    </div>
</template>

<script>

    import {mapState} from 'vuex'
    import store from '@/modules'

    export default {
        data() {
            const _this = this
            return {
                col: [
                    {title: '使用单位名称', key: 'siOrgName'},
                    {title: '信用代码', key: 'siOrgUscc'},
                    {title: '印章编码', key: 'siCode'},
                    {
                        title: '印章类型',
                        render: (h, w) => h("span", {
                            directives: [{
                                name: "dict",
                                value: w.row.siSealType,
                                arg: "DictSocietySealsite_sealType"
                            }]
                        })
                    },
                    {
                        title: '状态',
                        render: (h, w) => h("span", {
                            directives: [{
                                name: "dict",
                                value: w.row.state,
                                arg: "EntityGzwDzSeal_state"
                            }]
                        })
                    },
                    {
                        title: '付款状态',
                        render: (h, w) => h("span", {
                            directives: [{
                                name: "dict",
                                value: w.row.settleState,
                                arg: "EntityGzwDzSeal_settleState"
                            }]
                        })
                    },
                    {
                        title: "操作",
                        render: (h, w) => {
                            let arr = []
                            if (w.row.settleState == 0) {
                                arr.push(h('Button', {
                                    props: {type: 'text', size: 'small'},
                                    on: {
                                        click() {
                                            _this.$router.push({path: '/center/eSeal/eSealNew', query: {id: w.row.id}})
                                        }
                                    }
                                }, '填报'))
                                arr.push(h('Button', {
                                    props: {type: 'text', size: 'small'},
                                    on: {
                                        click() {
                                            _this.$Modal.confirm({
                                                title: "删除印章",
                                                content: "是否删除印章编码为" + w.row.code + "的印章?",
                                                onOk() {
                                                    _this.$store.dispatch('order/deleteEseal', {id: w.row.id})
                                                }
                                            })
                                        }
                                    }
                                }, '删除'))
                            }
                            if (w.row.settleState > 0) {
                                arr.push(h('Button', {
                                    props: {type: 'text', size: 'small'},
                                    on: {
                                        click() {
                                            _this.$router.push({path: '/center/eSeal/eSealInfo', query: {id: w.row.id}})
                                        }
                                    }
                                }, '查看'))
                            }

                            return arr
                        }
                    }
                ]
            }
        },
        computed: {
            ...mapState({
                sealActiveList: state => state.order.sealActiveList
            })
        },
        methods: {
            newEseal() {
                this.$router.push({path: '/center/eSeal/eSealNew'})
            },
            getSealActiveList(page) {
                if (page) {
                    this.$router.push({path: this.$route.path, query: {page: page}})
                }
                page = page || this.$route.query.page
                const param = {
                    sort: 'id,desc',
                    page: page ? page - 1 : null
                }
                store.dispatch('order/getSealActiveList', param)
            }
        },
        created() {
            this.getSealActiveList()
        }
    }
</script>

<style>

</style>
